import { useState } from "react"
import { Link } from "react-router-dom"

import SelectStyles from "../../../../../shared/css/SelectStyle"
import AuthBackgroundImage from "../../../../../shared/components/AuthImage/AuthBackgroundImage"
/* PRODUCT PICKER */
import Product from "../../../../product/Product"
//client img crud
import ListClientImg from "../../../../ClientImg/ListClientImg"
import ImageLightbox from "../../../../../shared/components/ImageLightbox/ImageLightbox"
//accessory
import Modal from '../../../../../shared/modal/Modal'

/* Hooks */
import useFlashMessage from '../../../../../hooks/useFlashMessage'

import RandomString from "../../../../../shared/functions/RandomString"
/* form */
import Input from "../../../../../shared/components/form/input"
import Radio from "../../../../../shared/components/form/Radio"
import Color from "../../../../color/content/ListColor"
import Acessory from "../../../../accessory/Accessory"
import ListAccessoryRow from "../../../../accessory/ListRow/ListAccessoryRow"
import ListAccessoryBudget from "../ListAccessoryBudget"
import useMyPermission from "../../../../../hooks/useMyPermission"

import NumberToMoney from "../../../../../shared/functions/NumberToMoney"
import findClothPurchaseRule from "../../../../../shared/functions/findClothPurchaseRule"
import getRefForCloth from "../../../../../shared/functions/getRefForCloth"

/* form select */
import Select from 'react-select'
import selectStyles from "../../../../../shared/css/SelectStyle"
import FormPrint from "../FormPrint/FormPrint"
import ListPrint from "../FormPrint/ListPrint"
import EditImgPrint from "./imgPrint/EditImgPrint"
import FormLayout from "../../../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../../../shared/components/FormLayout/FormSection"
import Button from "../../../../../shared/components/Button/Button"
import './FormBudgetItem.css'
import { FaTshirt, FaPalette, FaImage, FaStamp, FaGetPocket, FaTruck, FaRulerCombined, FaRuler, FaTags, FaVenusMars, FaCheckCircle, FaTrashAlt, FaEye, FaExclamationTriangle } from "react-icons/fa"
import { FaMoneyBillWave } from "react-icons/fa6"
import { FiEdit2 } from "react-icons/fi"
import { GiSewingMachine } from "react-icons/gi"

// Custo é por tecido (Color.costByCloth), não pela cor inteira — pega só as faixas
// de custo daquela cor pro tecido do produto selecionado. clothId null/"none" é o
// balde "sem tecido".
function costTiersForCloth(color, clothId) {
    const entries = color.costByCloth || []
    const entry = entries.find((e) => {
        const entryClothId = e.cloth?._id || e.cloth || null
        if (!clothId || clothId === 'none') return !entryClothId
        return entryClothId === clothId
    })
    return entry ? entry.costs : []
}

function FormBudgetItem({ handleSubmit, permission, handleOnSuccess, itemData, printsData, embroideryData, colorsData, additionalSizeData, sizesData, imgClientArrayData, additiveArrayData, accessoryArrayData, selectedItemData, commissionData, discountData, btnText, btnVariant, btCancelLink, btCancelAction, title, clientId }) {

    const [item, setItem] = useState(itemData || { printPrice: 0.0, embroideryPrice: 0.0, customCommissionStatus: false })
    const [additionalSize, setAddicionalSize] = useState(additionalSizeData || [])

    const [sizes, setSizes] = useState(sizesData || [])
    const [additiveArray, setAdditiveArray] = useState(additiveArrayData || [])
    const [accessoryArray, setAccessoryArray] = useState(accessoryArrayData || [])
    const [selectedItem, setSelectedItem] = useState(itemData || {})
    const [modalSelectProduct, setModalSelectProduct] = useState(false)
    const [pickerProduct, setPickerProduct] = useState(null)
    const { setFlashMessage } = useFlashMessage()
    const [modalColor, setModalColor] = useState(false)

    const [colors, setColors] = useState(colorsData || [])
    const [modalEditImgEmbroidery, setModalEditImgEmbroidery] = useState(false)
    const [modalSelectPrint, setModalSelectPrint] = useState(false)
    const [modalSelectEmbroidery, setModalSelectEmbroidery] = useState(false)
    const [embroidery, setEmbroidery] = useState(embroideryData || [])
    const [modalEditImgPrint, setModalEditImgPrint] = useState(false)
    const [editPrint, setEditPrint] = useState()
    const [prints, setPrints] = useState(printsData || [])
    const { checkPermission } = useMyPermission()
    const myPermissionCommissionEdit = checkPermission(permission, "budget_commission_edit")

    /* const [commission, setCommission] = useState(commissionData || 0)
    const [discount, setDiscount] = useState(discountData || 0) */


    // --------------------- ADD IMG ARRAY --------------
    const [imgClientArray, setImgClientArray] = useState(imgClientArrayData || [])
    const [modalClientImg, setModalClientImg] = useState(false)
    const addImgClientArray = (data) => {
        setImgClientArray(data)
        setModalClientImg(false)

    }
    const [lightboxClientImg, setLightboxClientImg] = useState(null)
    // --------------------- Select acessory --------------
    const [lightboxAccessory, setLightboxAccessory] = useState(null)
    const [modalSelectAccessory, setModalSelectAccessory] = useState(false)
    const addAccessory = (i) => {
        if (i._id) {
            setAccessoryArray([...accessoryArray, i])
            setModalSelectAccessory(false)
        }
    }
    const removeAccessory = (i) => {
        setAccessoryArray(prev => {
            return prev.filter((x) => x.id !== i.id)
        })
    }
    /* ----------------- function  money 0.00 ------------------- */
    function handleChangeMoney(e) {

        let value = NumberToMoney(e.target.value)

        setItem({ ...item, [e.target.name]: value })


    }
    const itemClothId = selectedItem.cloth ? selectedItem.cloth._id : null
    let cost = 0.0
    /* if (colors.length) {
        let obj = colors.reduce(function (prev, current) {
            return (prev.cost > current.cost) ? prev : current
        })
        cost = obj.cost
    } */
    if (colors.length) {

        let Q = totalCalcQuantity()
        let arrayCost = []
        //monta um array com os custos de acordo com a quantidade caso de uma ou mais cores selecionadas
        colors.map((i) => {
            costTiersForCloth(i, itemClothId).map((x) => {
                if(x.minUnit <= Q && Q <= x.maxUnit){
                    arrayCost = [...arrayCost, x.cost]
                }
            })
        })
        if (arrayCost.length) {
        let xx = arrayCost.reduce(function (prev, current) {
            return (prev> current) ? prev : current
        })
        cost = xx

    }
    console.log("cost")
    console.log(cost)
        


    }
    console.log("colors")
    console.log(colors)
    console.log("maior")
    console.log(cost)
    console.log("embroidery")
    console.log(embroidery)

    function handleSelectedItem(i) {
        if (selectedItem._id && selectedItem._id !== i._id) {
            setColors([])
        }
        setSelectedItem(i)
        if (i.sizeGrid.grid) {
            setSizes()
        }
        setSizes([])
        /*  if (i.gridType === "shirt") {
             setQuantitySize(quantitySizeShirt)
         } else if (i.gridType === "pants") {
             setQuantitySize(quantitySizePants)
         } else if (i.gridType === "formalShirt") {
             setQuantitySize(quantitySizeFormalShirt)
         } */
        if (i.additive) {
            setAdditiveArray(i.additive)
        }
        if (i.sizeGrid) {
            setSizes(i.sizeGrid.grid)
        }

    }
    function handleChange(e) {

        setItem({ ...item, [e.target.name]: e.target.value })

    }
    //------------------------------ Select Handle On Change --------------------------
    const handleSelectChange = (selectedOption) => {
        setItem({ ...item, [selectedOption.selectName]: selectedOption })


    }
    let commission = 0
    let discount = 0
    if (item.customCommissionStatus) {
        if (item.customCommission) {
            commission = item.customCommission
        }
        if (item.customDiscount) {
            discount = item.customDiscount
        }
    } else if (item.commission) {
        commission = item.commission.commission
        discount = item.commission.discount
    }
    console.log("select commission 2")
    console.log(commission)
    console.log(discount)
    //Radio form start
    const handleChangeRadio = (name, value) => {

        setItem({ ...item, [name]: value })
    }

    //Radio form end


    const productSelected = !!selectedItem._id

    /* -------------------------Color ----------------------------------- */
    /* COLOR FILTER */
    let filterProvider = "none"
    let filterCloth = "none"
    if (selectedItem.provider) {
        filterProvider = selectedItem.provider._id
    }
    if (selectedItem.cloth) {
        filterCloth = selectedItem.cloth._id
    }

    const clothRule = findClothPurchaseRule(selectedItem.provider, selectedItem.cloth?._id)

    // Não tem como converter kg↔metro (depende da densidade do tecido, que o sistema não
    // conhece) — mas um descompasso de unidade entre o que o fornecedor declarou e a unidade
    // do Produto é um problema de cadastro, não pode passar batido: em vez de desativar a
    // checagem em silêncio, sinaliza o descompasso explicitamente (minPurchaseUnitMismatch).
    const minPurchaseUnitMismatch = !!(clothRule && selectedItem.unit && clothRule.unit?.value !== selectedItem.unit.value)
    // O mínimo de compra é opcional dentro da regra — só existe checagem se a regra realmente
    // tiver um valor mínimo preenchido (a regra pode existir só pra declarar a unidade).
    const applicableMinPurchase = clothRule && !minPurchaseUnitMismatch && clothRule.minPurchaseValue ? clothRule : null
    /*  const handleOnSelectedColor = (i) => {
 
         setModalColor(false)
         setColor(i)
     } */
    function checkAdditive(id, option) {

        setAdditiveArray((prev) => {
            return prev.map((i) => {
                if (i._id === id) {
                    return { ...i, checked: option }
                } else {
                    return { ...i }
                }
            })
        })

    }


    /* ----------------------------------- price Total function ------------------------- */

    const calcTotalPrice = (percent) => {
        let array = []
        if (selectedItem.sizeGrid) {
            array = selectedItem.sizeGrid.grid
        }

        let price = 0.0
        console.log("------------------- total -----------------------------")
        console.log(array)
        array.map((i) => {
            let quant = getItem(i.name, "quantity")
            console.log(`quant ${quant} `)
            let key = `price${i}`
            price = parseFloat(priceCalc(quant, percent, i.price, discount)) + price

        })

        return NumberToMoney(price)
    }
    /* funçao principal para calcular os valores */
    const priceCalc = (quantity, percent, sizePrice, dis) => {

        let price = 0
        let additiveTotal = 0.0
        let accessoryTotal = 0.0
        let sizeAdditional = sizePrice
        if (!sizePrice) {
            sizeAdditional = 0.0
        }
        if (!quantity) {
            return "0.00"
        }

        additiveArray.map((i) => {
            if (i.checked === true) {
                additiveTotal = additiveTotal + parseFloat(i.price)

            }
        })
        accessoryArray.map((i) => {
            // i.price é o campo atual; i.cost é o nome antigo do mesmo valor, ainda presente
            // no accessoriesSelected de orçamentos salvos antes dessa mudança — sem o fallback,
            // reabrir um orçamento antigo pra editar zeraria o valor desses acessórios no preço.
            const accessoryPrice = i.price ?? i.cost
            if (accessoryPrice) {
                accessoryTotal = accessoryTotal + parseFloat(accessoryPrice)

            }
        })

        if (cost) {
            if (selectedItem.unit) {

                if (selectedItem.unit.value === "m") {
                    // price = (((parseFloat(cost) * parseFloat(selectedItem.measure)) + parseFloat(selectedItem.labor) + parseFloat(item.embroideryPrice) + parseFloat(item.printPrice) + additiveTotal) * (1 + parseFloat(percent) / 100)) * (1 + parseFloat(selectedItem.percentOfSale) / 100)
                    price = (((parseFloat(cost) * parseFloat(selectedItem.measure)) + parseFloat(selectedItem.labor)) * (1 + parseFloat(percent) / 100)) * (1 + parseFloat(selectedItem.percentOfSale) / 100)

                } else if (selectedItem.unit.value === "kg") {
                    price = (((parseFloat(cost) / parseFloat(selectedItem.measure)) + parseFloat(selectedItem.labor)) * (1 + parseFloat(percent) / 100)) * (1 + parseFloat(selectedItem.percentOfSale) / 100)
                }
                price = price * (1 - parseFloat(dis) / 100)
                price = price + parseFloat(printTotalCalc(embroidery)) + parseFloat(printTotalCalc(prints)) + additiveTotal
                price = quantity * (price + accessoryTotal + parseFloat(sizeAdditional))

            }
        }
        return NumberToMoney(price)
    }
    const calcCommission = (perCent) => {
        let total = parseFloat(calcTotalPrice(perCent)) * (commission / 100)
        if (total) {
            return NumberToMoney(total)
        }
        return "0.00"
    }
    function calcSizePrice(price, perCent, sizePrice, quant) {
        let additiveTotal = 0.0
        additiveArray.map((i) => {
            if (i.checked === true) {
                additiveTotal = additiveTotal + parseFloat(i.price)

            }


        })
        let val = (parseFloat(price)) + (((parseFloat(additiveTotal) + parseFloat(sizePrice)) * (1 + parseFloat(perCent) / 100)) * (1 + parseFloat(item.percentOfSale) / 100))
        val = val * quant
        val = val.toFixed(2)

        return val
    }
    /* calculo total de quantidade */
    function sizeQuantity(id) {
        let obj = {}
        obj = sizes.find((i) => i._id == id)

        if (obj) {
            return obj.quantity
        }

        return ""
    }
    /*  ---------------------------------------------------------------------------------- */
    // ------------------------------------- TOTAL CALC EMBROIDERY AND PRINT --------------------------------
    function printTotalCalc(array) {
        let total = 0
        array.map((i) => {
            total = total + parseFloat(i.price)
        })

        return total

    }
    function handleChangeSize(e) {
        const newArray = sizes.map((i) => {
            if (i._id == e.target.id) {
                return { ...i, quantity: e.target.value, unPriceCash: priceCalc(1, selectedItem.inCash, i.price, discount), unPriceInstalment: priceCalc(1, selectedItem.instalment, i.price, discount), totalPriceCash: priceCalc(e.target.value, selectedItem.inCash, i.price, discount), totalPriceInstalment: priceCalc(e.target.value, selectedItem.instalment, i.price, discount) }
            }
            return i
        })
        setSizes(newArray)

    }
    console.log("sizes")
    console.log(sizes)
    /* pega o item especifico do array size */
    function getItem(name, key) {
        if (name && key) {

            let obj = sizes.find((i) => i.name == name)

            if (obj) {
                let i = obj[key]
                if (i) {
                    return i
                }
            }
        }
        return ""
    }



    function totalCalcQuantity() {
        let quant = 0
        sizes.map((i) => {
            if (i.quantity) {
                quant = quant + parseInt(i.quantity)
            }
        })

        return quant
    }

    /* consumo total de matéria-prima (kg ou metros) com base na quantidade de peças e na "Medida" do produto:
       unidade metro -> medida = metros gastos por peça (multiplica)
       unidade kg -> medida = peças rendidas por kg (divide) */
    function totalMaterialConsumed() {
        const qty = totalCalcQuantity()
        const measure = parseFloat(selectedItem.measure)
        if (!selectedItem.unit || !measure) {
            return 0
        }
        if (selectedItem.unit.value === "m") {
            return qty * measure
        }
        if (selectedItem.unit.value === "kg") {
            return qty / measure
        }
        return 0
    }

    const grid = () => {

        let array = []
        if (sizes) {
            array = sizes
        }

        return (
            array.map((i) =>
                <tr key={i._id}>
                    <td>
                        <div className="budget-size-box-item">
                            <div className="input-m-3 ">
                                <div className="budget-size-box-item-name">{i.name}</div>
                            </div>
                        </div>
                    </td>


                    <td>
                        <div className="budget-size-box-item">
                            <div className="input-m-3 ">
                                <Input

                                    type="number"
                                    name={i.name}
                                    id={i._id}
                                    placeholder="Digite a quantidade"
                                    handleOnChange={handleChangeSize}
                                    value={sizeQuantity(i._id)}

                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="budget-size-box-item">
                            <div className="input-m-3 ">
                                <div className='input-block'>R$ {priceCalc(1, selectedItem.inCash, i.price, 0)}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="budget-size-box-item">
                            <div className="input-m-3 ">
                                <div className='input-block'>R$ {priceCalc(1, selectedItem.inCash, i.price, discount)}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="budget-size-box-item">
                            <div className="input-m-4 ">
                                <div className='input-block'>R$ {priceCalc(sizeQuantity(i._id), selectedItem.inCash, i.price, 0)} </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="budget-size-box-item">
                            <div className="input-m-4 ">
                                <div className='input-block'>R$ {priceCalc(sizeQuantity(i._id), selectedItem.inCash, i.price, discount)}</div>
                            </div>
                        </div>
                    </td>

                </tr>)

        )
    }
    const loadSizes = () => {
        let data = []
        sizes.map((i) => {
            data = [
                ...data,
                {
                    id: i.id,
                    size: i.size,
                    quantity: i.quantity,
                    unitInCash: priceCalc(1, selectedItem.inCash, i.price, 0),
                    unitInCashDis: priceCalc(1, selectedItem.inCash, i.price, discount),
                    totalInCashDis: priceCalc(sizeQuantity(i), selectedItem.inCash, i.price, discount),
                    unitInstalment: priceCalc(1, selectedItem.instalment, i.price, 0),
                    unitInInstalmentDis: priceCalc(1, selectedItem.instalment, i.price, discount),
                    totalInstalmentDis: priceCalc(sizeQuantity(i), selectedItem.instalment, i.price, discount),
                }]
        })
        return data
    }
    console.log("selectedItem")
    console.log(selectedItem)
    const submit = () => {
        if (!selectedItem._id) {
            setFlashMessage("Selecione um produto ", 'error')
            return
        }
        if (!colors.length) {
            setFlashMessage("Selecione uma cor", 'error')
            return
        }
        console.log("item.commission")
        console.log(item.commission)
        if (item.customCommissionStatus === true) {
            if (!item.customCommission) {
                setFlashMessage("Nenhuma comissão personalizada preenchida", 'error')
                return
            }
            if (!item.customDiscount) {
                setFlashMessage("Nenhum desconto personalizado preenchido", 'error')
                return
            }

        } else {
            if (!item.commission) {
                setFlashMessage("Selecione um desconto e comissão", 'error')
                return
            }
        }
        /* if (!item.commission) {
            setFlashMessage("Selecione um desconto e comissão", 'error')
            return
        } */
        if (parseInt(totalCalcQuantity()) === 0) {
            setFlashMessage("Selecione uma quantidade minima", 'error')
            return
        }
        if (minPurchaseUnitMismatch) {
            setFlashMessage(`A unidade cadastrada para esse fornecedor+tecido (${clothRule.unit.label}) não bate com a unidade do produto (${selectedItem.unit.label}) — corrija o cadastro do fornecedor antes de continuar`, 'error')
            return
        }
        if (applicableMinPurchase && totalMaterialConsumed() < applicableMinPurchase.minPurchaseValue) {
            setFlashMessage(`O fornecedor selecionado só aceita vendas de no mínimo ${applicableMinPurchase.minPurchaseValue} ${applicableMinPurchase.unit.label}`, 'error')
            return
        }

        let data = selectedItem

        let text = ""
        if (data.provider) {
            text = text + data.provider.label
        }
        if (data.category) {
            text = text + " " + data.category.label
        }
        if (data.cloth) {
            text = text + " " + data.cloth.label
        }
        if (data.sex) {
            text = text + " " + data.sex.label
        }
        if (colors.length) {
            colors.map((i) => {
                text = text + ", cor: " + i.label
            })
        }
        if (additiveArray.length) {
            additiveArray.map((i) => {
                if (i.checked) {

                    text = text + ", com " + i.name
                } else {
                    text = text + ", sem " + i.name
                }

            })
        }
        if (accessoryArray.length) {
            accessoryArray.map((i) => {
                text = text + ", com " + i.name


            })
        }




        data = { ...data, sizes: sizes, colors: colors, additive: additiveArray, clientImgsSelected: imgClientArray, accessoriesSelected: accessoryArray, commissionSelected: item.commission, discountValue: discount, commissionValue: commission, totalQuantity: totalCalcQuantity(), totalInCash: calcTotalPrice(selectedItem.inCash), totalInstalment: calcTotalPrice(selectedItem.instalment) }
        data = { ...item, ...data }
        data = { ...data, commission: item.commission, description: text, prints: prints, embroidery: embroidery }
        console.log("DATA FINAL")
        console.log(data)
        handleSubmit(data)
        handleOnSuccess()
    }
    return (
        <FormLayout
            title={title || 'Adicionar Item'}
            actions={
                <>
                    <Button variant={btnVariant || 'save'} onClick={() => submit()}>{btnText || 'Salvar'}</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            {/*  -------------------- product select + selected ------------------------------ */}
            <FormSection label="Produto">
                <button type="button" className="budget-select-btn" onClick={() => { setPickerProduct(selectedItem._id ? selectedItem : null); setModalSelectProduct(true) }}>
                    <FaTshirt size={16} /><span>Selecionar Produto</span>
                </button>
                {/* modal select product */}
                <Modal
                    modalStatus={modalSelectProduct}
                    changeStatus={setModalSelectProduct}
                    w={90}
                    t={2}
                    h={90}
                    content={
                        <Product
                            enableSelectRow={true}
                            itemData={pickerProduct}
                            handleOnSelected={(i) => setPickerProduct(i)}
                            onFinishSelect={() => { if (pickerProduct) { handleSelectedItem(pickerProduct); setModalSelectProduct(false) } }}
                        />
                    }
                />

                {productSelected ? (
                    <div className="bspc">
                        <div className="bspc-badge"><FaCheckCircle size={11} /><span>Produto selecionado</span></div>
                        <div className="bspc-content">
                            <div className="bspc-header">
                                <span className="bspc-title">{selectedItem.description}</span>
                                <span className="bspc-code">#{selectedItem.code}</span>
                            </div>
                            <div className="bspc-grid">
                                {selectedItem.provider?.name && (
                                    <div className="bspc-field"><FaTruck className="bspc-icon" size={13} /><span>{selectedItem.provider.name}</span></div>
                                )}
                                {selectedItem.cloth?.name && (
                                    <div className="bspc-field"><FaTshirt className="bspc-icon" size={13} /><span>{selectedItem.cloth.name}</span></div>
                                )}
                                {selectedItem.category?.name && (
                                    <div className="bspc-field"><FaTags className="bspc-icon" size={13} /><span>{selectedItem.category.name}</span></div>
                                )}
                                {selectedItem.sex?.label && (
                                    <div className="bspc-field"><FaVenusMars className="bspc-icon" size={13} /><span>{selectedItem.sex.label}</span></div>
                                )}
                                {selectedItem.colorType?.name && (
                                    <div className="bspc-field"><FaPalette className="bspc-icon" size={13} /><span>{selectedItem.colorType.name}</span></div>
                                )}
                                {selectedItem.sizeGrid?.name && (
                                    <div className="bspc-field"><FaRulerCombined className="bspc-icon" size={13} /><span>{selectedItem.sizeGrid.name}</span></div>
                                )}
                                {selectedItem.measure && selectedItem.unit?.value && (
                                    <div className="bspc-field"><FaRuler className="bspc-icon" size={13} /><span>{selectedItem.measure} {selectedItem.unit.value}</span></div>
                                )}
                            </div>
                            {selectedItem.totalInCash && (
                                <div className="bspc-price"><FaMoneyBillWave size={13} />R$ {selectedItem.totalInCash} à vista</div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="bspc-empty">
                        <FaTshirt size={16} />
                        <span>Nenhum produto selecionado ainda.</span>
                    </div>
                )}
            </FormSection>

            {/* -----------------------------------------color ---------------------------------- */}
            <FormSection label="Cor">
                <button type="button" className="budget-select-btn" disabled={!productSelected} onClick={() => setModalColor(true)}>
                    <FaPalette size={16} /><span>Selecionar Cor</span>
                </button>
                {!productSelected && <span className="budget-select-hint">Selecione um produto primeiro</span>}
                    {/* modal colors */}
                    <Modal
                        modalStatus={modalColor}
                        changeStatus={setModalColor}
                        w={90}
                        t={2}
                        content={
                            <>
                                <Color enableSelect={true} filterProvider={filterProvider} filterCloth={filterCloth} handleSelect={(i) => { setModalColor(false); setColors([...colors, i]); }} />
                            </>
                        }

                    />
                    {colors.length > 0 ? (
                        <div className="bspc">
                            <div className="bspc-badge"><FaCheckCircle size={11} /><span>{colors.length > 1 ? 'Cores selecionadas' : 'Cor selecionada'}</span></div>
                            <div className="bspc-content bscc-list">
                                {colors.map((item) => (
                                    <div className="bscc-item" key={item._id}>
                                        <AuthBackgroundImage className="bscc-swatch" src={item.image ? `/images/color/${item.image}` : null} />
                                        <div className="bscc-info">
                                            <div className="bscc-name">{item.name}</div>
                                            <div className="bscc-meta">
                                                {item.provider?.name && <span className="bscc-meta-item"><FaTruck size={11} />{item.provider.name}</span>}
                                                {item.cloths?.length > 0 && <span className="bscc-meta-item"><FaTshirt size={11} />{item.cloths.map((c) => c.name).join(', ')}</span>}
                                                {item.colorType?.name && <span className="bscc-meta-item"><FaPalette size={11} />{item.colorType.name}</span>}
                                            </div>
                                            <div className="bscc-ref">Ref.: {getRefForCloth(item, itemClothId)}</div>
                                            {costTiersForCloth(item, itemClothId).length > 0 ? (
                                                <div className="bscc-cost-list">
                                                    {costTiersForCloth(item, itemClothId).map((i) => (
                                                        <span className="bscc-cost-tier" key={i._id}>{i.minUnit}–{i.maxUnit} un.: R$ {NumberToMoney(i.cost)}</span>
                                                    ))}
                                                </div>
                                            ) : (
                                                <span className="bscc-cost-tier bscc-cost-missing">Sem custo definido pra esse tecido</span>
                                            )}
                                        </div>
                                        <button type="button" className="bscc-remove" title="Remover" onClick={() => setColors(prev => prev.filter((x) => x._id !== item._id))}>
                                            <FaTrashAlt size={13} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="bspc-empty">
                            <FaPalette size={16} />
                            <span>Nenhuma cor selecionada ainda.</span>
                        </div>
                    )}
            </FormSection>

            {/* Aditivo */}
            <FormSection label={<>Aditivo <span className="fl-section-optional">(opcional)</span></>}>
                {additiveArray.length > 0 ? (
                    <div className="budget-additive-list">
                        {additiveArray.map((i) => (
                            <Radio
                                key={i._id}
                                options={[
                                    { value: false, label: `Sem ${i.name}` },
                                    { value: true, label: <>Com {i.name} <span className="budget-additive-price"><FaMoneyBillWave size={11} />+R$ {NumberToMoney(i.price)}</span></> },
                                ]}
                                name={i._id}
                                value={i.checked}
                                defaultValue={false}
                                handleOnChange={(name, val) => checkAdditive(i._id, val)}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="bspc-empty">
                        <span>{productSelected ? 'Este produto não possui aditivos.' : 'Selecione um produto para ver os aditivos disponíveis.'}</span>
                    </div>
                )}
            </FormSection>

            {/* -------------------------- CLIENT IMG -------------------------------------- */}
            <FormSection label={<>Imagens de Referência do Cliente <span className="fl-section-optional">(opcional)</span></>}>
                <button type="button" className="budget-select-btn" disabled={!productSelected} onClick={() => setModalClientImg(true)}>
                    <FaImage size={16} /><span>Selecionar Imagem</span>
                </button>
                {!productSelected && <span className="budget-select-hint">Selecione um produto primeiro</span>}

                {imgClientArray.length > 0 ? (
                    <div className="budget-clientimg-grid">
                        {imgClientArray.map((item) => (
                            <div className="budget-clientimg-tile" key={item._id}>
                                <div className="budget-clientimg-imgwrap">
                                    <AuthBackgroundImage className="budget-clientimg-bg" src={item.image ? `/images/clientImg/${item.image}` : null} onClick={() => setLightboxClientImg(item)} />
                                    {item.image && (
                                        <div className="budget-clientimg-zoom-hint">
                                            <FaEye size={20} />
                                        </div>
                                    )}
                                </div>
                                <button type="button" className="budget-clientimg-remove" title="Remover" onClick={() => setImgClientArray(prev => prev.filter((x) => x._id !== item._id))}>
                                    <FaTrashAlt size={11} /><span>Remover</span>
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="bspc-empty">
                        <FaImage size={16} />
                        <span>Nenhuma imagem selecionada ainda.</span>
                    </div>
                )}

                <Modal
                    modalStatus={modalClientImg}
                    changeStatus={setModalClientImg}
                    w={85}
                    content={
                        <>
                            <ListClientImg clientId={clientId} pageMode={'modal'} handleOnCancel={setModalClientImg} handleOnAddImg={addImgClientArray} selectedArray={imgClientArray} />
                        </>
                    }
                />

                <ImageLightbox
                    src={lightboxClientImg ? `/images/clientImg/${lightboxClientImg.image}` : null}
                    alt="Imagem de referência"
                    onClose={() => setLightboxClientImg(null)}
                />
            </FormSection>

            {/* -------------------------------------Bordado ---------------------------------- */}
            <FormSection label={<>Bordado <span className="fl-section-optional">(opcional)</span></>}>
                <button type="button" className="budget-select-btn" disabled={!productSelected} onClick={() => setModalSelectEmbroidery(true)}>
                    <GiSewingMachine size={16} /><span>Adicionar Bordado</span>
                </button>
                {!productSelected && <span className="budget-select-hint">Selecione um produto primeiro</span>}
                <Modal
                    modalStatus={modalSelectEmbroidery}
                    changeStatus={setModalSelectEmbroidery}
                    w={60}
                    h={70}
                    content={
                        <FormPrint title={"Adicionar Bordado"} handleOnSubmit={(data) => { setEmbroidery([...embroidery, data]); setModalSelectEmbroidery(false) }} btnText={"Salvar"} btCancelAction={() => setModalSelectEmbroidery(false)} />
                    }
                />

                {embroidery.length > 0 ? (
                    <div className="budget-print-list">
                        {embroidery.map((item) => (
                            <div className="budget-print-item" key={item._id}>
                                <div className="budget-print-thumb" onClick={() => item.image && setLightboxClientImg(item)}>
                                    <AuthBackgroundImage className="budget-print-thumb-bg" src={item.image ? `/images/clientImg/${item.image}` : null} />
                                    {item.image && (
                                        <div className="budget-print-thumb-zoom">
                                            <FaEye size={14} />
                                        </div>
                                    )}
                                    <button type="button" className="budget-print-thumb-edit" title="Editar imagem" onClick={(e) => { e.stopPropagation(); setModalEditImgEmbroidery(true); setEditPrint(item) }}>
                                        <FiEdit2 size={11} />
                                    </button>
                                </div>
                                <div className="budget-print-info">
                                    <span className="budget-print-position">{item.position.label}</span>
                                    {item.description && <span className="budget-print-desc">{item.description}</span>}
                                    <span className="budget-print-price">R$ {NumberToMoney(item.price)}</span>
                                </div>
                                <button type="button" className="budget-print-remove" title="Remover" onClick={() => setEmbroidery(prev => prev.filter((x) => x._id !== item._id))}>
                                    <FaTrashAlt size={12} />
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="bspc-empty">
                        <GiSewingMachine size={16} />
                        <span>Nenhum bordado adicionado ainda.</span>
                    </div>
                )}

                {/* Modal change img embroidery */}
                <Modal
                    modalStatus={modalEditImgEmbroidery}
                    changeStatus={setModalEditImgEmbroidery}
                    w={60}
                    h={70}
                    content={
                        <EditImgPrint clientId={clientId}
                            title={"Editar Imagem do Bordado"}
                            btCancelAction={() => setModalEditImgEmbroidery(false)}
                            handleOnSelect={(img) => {
                                const data = embroidery.map((i) => {
                                    if (editPrint._id === i._id) {
                                        return { ...i, image: img.image }
                                    } else {
                                        return i
                                    }
                                })
                                setEmbroidery(data)
                            }}
                        />
                    }
                />

                <div className="shd-form-flex">
                    <div className="shd-form-col-1 form-group">
                        <div className="input-m-2">
                            <Input
                                styles="formGroup col400px"
                                text="Valor do Bordado"
                                type="number"
                                name="embroideryPrice"
                                placeholder="Valor do bordado"
                                handleOnBlur={handleChangeMoney}
                                value={NumberToMoney(printTotalCalc(embroidery)) || 0.00}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            {/* --------------------------------- PRINT ------------------------------------------------- */}
            <FormSection label={<>Estampa <span className="fl-section-optional">(opcional)</span></>}>
                <button type="button" className="budget-select-btn" disabled={!productSelected} onClick={() => setModalSelectPrint(true)}>
                    <FaStamp size={16} /><span>Adicionar Estampa</span>
                </button>
                {!productSelected && <span className="budget-select-hint">Selecione um produto primeiro</span>}
                <Modal
                    modalStatus={modalSelectPrint}
                    changeStatus={setModalSelectPrint}
                    w={60}
                    h={70}
                    content={
                        <FormPrint title={"Adicionar Estampa"} handleOnSubmit={(data) => { setPrints([...prints, data]); setModalSelectPrint(false) }} btnText={"Salvar"} btCancelAction={() => setModalSelectPrint(false)} />
                    }
                />

                {prints.length > 0 ? (
                    <div className="budget-print-list">
                        {prints.map((item) => (
                            <div className="budget-print-item" key={item._id}>
                                <div className="budget-print-thumb" onClick={() => item.image && setLightboxClientImg(item)}>
                                    <AuthBackgroundImage className="budget-print-thumb-bg" src={item.image ? `/images/clientImg/${item.image}` : null} />
                                    {item.image && (
                                        <div className="budget-print-thumb-zoom">
                                            <FaEye size={14} />
                                        </div>
                                    )}
                                    <button type="button" className="budget-print-thumb-edit" title="Editar imagem" onClick={(e) => { e.stopPropagation(); setModalEditImgPrint(true); setEditPrint(item) }}>
                                        <FiEdit2 size={11} />
                                    </button>
                                </div>
                                <div className="budget-print-info">
                                    <span className="budget-print-position">{item.position.label}</span>
                                    {item.description && <span className="budget-print-desc">{item.description}</span>}
                                    <span className="budget-print-price">R$ {NumberToMoney(item.price)}</span>
                                </div>
                                <button type="button" className="budget-print-remove" title="Remover" onClick={() => setPrints(prev => prev.filter((x) => x._id !== item._id))}>
                                    <FaTrashAlt size={12} />
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="bspc-empty">
                        <FaStamp size={16} />
                        <span>Nenhuma estampa adicionada ainda.</span>
                    </div>
                )}

                {/* Modal change img print */}
                <Modal
                    modalStatus={modalEditImgPrint}
                    changeStatus={setModalEditImgPrint}
                    w={60}
                    h={70}
                    content={
                        <EditImgPrint clientId={clientId}
                            title={"Editar Imagem da Estampa"}
                            btCancelAction={() => setModalEditImgPrint(false)}
                            handleOnSelect={(img) => {
                                const data = prints.map((i) => {
                                    if (editPrint._id === i._id) {
                                        return { ...i, image: img.image }
                                    } else {
                                        return i
                                    }
                                })
                                setPrints(data)
                            }}
                        />
                    }
                />

                <div className="shd-form-flex">
                    <div className="shd-form-col-1 form-group">
                        <div className="input-m-2">
                            <Input
                                styles="formGroup col400px"
                                text="Valor da Estampa"
                                type="number"
                                name="printPrice"
                                placeholder="Valor da estampa"
                                handleOnBlur={handleChangeMoney}
                                value={NumberToMoney(printTotalCalc(prints)) || 0.00}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            {/* -------------------------- ACESSORY -------------------------------------- */}
            <FormSection label={<>Acessórios <span className="fl-section-optional">(opcional)</span></>}>
                <button type="button" className="budget-select-btn" disabled={!productSelected} onClick={() => setModalSelectAccessory(true)}>
                    <FaGetPocket size={16} /><span>Adicionar Acessório</span>
                </button>
                {!productSelected && <span className="budget-select-hint">Selecione um produto primeiro</span>}
                <Modal
                    modalStatus={modalSelectAccessory}
                    changeStatus={setModalSelectAccessory}
                    w={85}
                    content={
                        <ListAccessoryBudget handleSelect={addAccessory} />
                    }
                />

                {accessoryArray.length > 0 ? (
                    <div className="budget-accessory-list">
                        {accessoryArray.map((item) => (
                            <div className="budget-accessory-item" key={item.id}>
                                <div className="budget-accessory-thumb-wrap" onClick={() => item.image && setLightboxAccessory(item)}>
                                    <AuthBackgroundImage className="budget-accessory-thumb" src={item.image ? `/images/accessory/${item.image}` : null} />
                                    {item.image && (
                                        <div className="budget-accessory-thumb-zoom">
                                            <FaEye size={14} />
                                        </div>
                                    )}
                                </div>
                                <div className="budget-accessory-info">
                                    <span className="budget-accessory-name">{item.name}</span>
                                    {item.description && <span className="budget-accessory-desc">{item.description}</span>}
                                    {(item.price ?? item.cost) > 0 && <span className="budget-accessory-cost">R$ {NumberToMoney(item.price ?? item.cost)}</span>}
                                </div>
                                <button type="button" className="budget-accessory-remove" title="Remover" onClick={() => removeAccessory(item)}>
                                    <FaTrashAlt size={12} />
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="bspc-empty">
                        <FaGetPocket size={16} />
                        <span>Nenhum acessório adicionado ainda.</span>
                    </div>
                )}

                <ImageLightbox
                    src={lightboxAccessory ? `/images/accessory/${lightboxAccessory.image}` : null}
                    alt="Acessório"
                    onClose={() => setLightboxAccessory(null)}
                />
            </FormSection>

            {/* -------------------------- OBSERVAÇÕES -------------------------------------- */}
            <FormSection label={<>Observações <span className="fl-section-optional">(opcional)</span></>}>
                <Input
                    type="textarea"
                    name="obs"
                    placeholder="Digite observações sobre o item"
                    handleOnChange={handleChange}
                    value={item.obs || ''}
                />
            </FormSection>

            {/* -------------------------- DISCOUNT AND COMMISSION SELECT -------------------------------- */}
            <FormSection label="Desconto e Comissão">
                <div className="fl-row budget-discount-row">
                    <div className="fl-col-mid form-group" style={{ maxWidth: '320px' }}>
                        <Radio
                            options={[{ value: false, label: "Desconto e comissão padrão" }]}
                            name="customCommissionStatus"
                            value={item.customCommissionStatus}
                            defaultValue={false}
                            handleOnChange={(name, val) => setItem({ ...item, customCommissionStatus: val })}
                        />
                        <Select
                            options={selectedItem.commissions}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={item.commission || {}}
                            isDisabled={item.customCommissionStatus}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>

                <div className="fl-row budget-discount-row">
                    <div className="fl-col-wide form-group">
                        <Radio
                            options={[{ value: true, label: "Desconto e comissão personalizado" }]}
                            name="customCommissionStatus"
                            value={item.customCommissionStatus}
                            defaultValue={false}
                            handleOnChange={(name, val) => {
                                if (myPermissionCommissionEdit) {
                                    setItem({ ...item, customCommissionStatus: val })
                                }
                            }}
                        />
                    </div>
                </div>

                <div className="fl-row budget-discount-row budget-discount-row-tight">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Comissão personalizada (%)"
                            type="number"
                            name="customCommission"
                            placeholder="Comissão"
                            disabled={!myPermissionCommissionEdit}
                            handleOnChange={handleChange}
                            value={item.customCommission || ''}
                        />
                    </div>
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Desconto personalizado (%)"
                            type="number"
                            name="customDiscount"
                            placeholder="Desconto"
                            disabled={!myPermissionCommissionEdit}
                            handleOnChange={handleChange}
                            value={item.customDiscount || ''}
                        />
                    </div>
                </div>
            </FormSection>

            {/* --------------------------------- Grade de Tamanhos ---------------------------------------- */}
            <FormSection label="Tamanhos e Totais">
                {minPurchaseUnitMismatch && (
                    <div className="budget-min-purchase">
                        <FaExclamationTriangle size={13} />
                        <span>Cadastro inconsistente: a regra de compra desse fornecedor+tecido está em {clothRule.unit.label}, mas o produto usa {selectedItem.unit.label} — corrija o cadastro do fornecedor</span>
                    </div>
                )}
                {applicableMinPurchase && (
                    <div className={`budget-min-purchase ${totalMaterialConsumed() >= applicableMinPurchase.minPurchaseValue ? 'budget-min-purchase-met' : ''}`}>
                        {totalMaterialConsumed() >= applicableMinPurchase.minPurchaseValue ? <FaCheckCircle size={13} /> : <FaExclamationTriangle size={13} />}
                        <span>Esse fornecedor exige o mínimo de {applicableMinPurchase.minPurchaseValue} {applicableMinPurchase.unit.label} de tecido</span>
                    </div>
                )}
                {additionalSize &&
                    (
                        <div className="budget-subitem">
                                <table>
                                    <tr>

                                        <th><div className="budget-size-box-item">Tamanhos</div></th>
                                        <th><div className="budget-size-box-item">Quantidade</div></th>
                                        <th><div className="budget-size-box-item">Un.</div></th>
                                        <th><div className="budget-size-box-item">Un. c/desc.</div></th>
                                        <th><div className="budget-size-box-item">Total</div></th>
                                        <th><div className="budget-size-box-item">Total c/desc </div></th>

                                    </tr>
                                    {grid()}
                                </table>
                            </div>
                        )}

                    <div className="budget-subitem">
                        <div className="shd-bt-box-flex">

                            <div className='input-m-3 form-group'>
                                <label>Quantidade</label>
                                <div className='input-block'> {totalCalcQuantity()} </div>
                            </div>

                            <div className='input-m-2 form-group'>
                                <label>Total à vista</label>
                                <div className='input-block'> R$ {calcTotalPrice(parseFloat(selectedItem.inCash))}</div>
                            </div>
                            <div className='input-m-2 form-group'>
                                <label>Total parcelado</label>
                                <div className='input-block'> R$ {calcTotalPrice(parseFloat(selectedItem.instalment))} </div>
                            </div>
                            <div className='input-m-2 form-group'>
                                <label>Comissão</label>
                                <div className='input-block'> R$ {calcCommission(parseFloat(selectedItem.inCash))}</div>
                            </div>



                        </div>
                    </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormBudgetItem